<!--带有分页逻辑的table-->
<template>
  <div class="vm-page-table-v2">
    <div
        v-if="!hideShowHideBtn&&$slots.adSearch"
        class="toggle-ad-search"
        @click="toggleAdSearch">
      {{showAdSearch ? "隐藏" : "显示"}}查询
    </div>
    <div id="vm-table-bar">
      <div
          v-if="$slots.toolbar||(batchDeleteUrl&&showBatchDeleteBtn)"
          class="tools-bar">
        <slot name="toolbar"/>
        <el-button v-if="batchDeleteUrl" type="danger" :loading="deleteLoading" @click="onBatchDelete">
          批量删除
        </el-button>
        <div v-if="showTimeRange" style="flex: 1;text-align: right;margin-right: 55px">
          <span style="font-size: 13px;margin-right: 5px;">订单时间</span>
          <el-radio-group v-model="timeRange" fill="#F56C6C">
            <el-radio-button label="all">全部</el-radio-button>
            <el-radio-button label="m6">最近半年</el-radio-button>
          </el-radio-group>
        </div>
      </div>
      <div
          v-if="$slots.adSearch&&showAdSearch"
          ref="adSearch"
          class="ad-search">
        <div :id="'vm-search-'+_uid" class="ad-search_content">
          <slot name="adSearch"/>
        </div>
        <div class="ad-search-btn">
          <el-button
              :disabled="status==='loading'"
              style="height: 26px;padding: 0 10px"
              type="primary"
              @click="handleSearchClick">
            查询
          </el-button>
          <el-button
              v-if="!hideClear"
              plain
              :disabled="status==='loading'"
              style="height: 26px;padding: 0 8px"
              type="primary"
              @click="handleClearClick">
            重置
          </el-button>
          <el-button
              v-if="showExport"
              :loading="exportLoading"
              :disabled="status==='loading'"
              type="success"
              style="height: 26px;padding: 0 8px"
              @click="handleExport">
            导出
          </el-button>
        </div>
      </div>
      <div
          v-if="$slots.tip"
          class="tip">
        <slot name="tip"/>
      </div>
    </div>
    <div class="wrapper">
      <el-table
          ref="elTable"
          :data="tableData"
          border
          stripe
          :span-method="spanMethod"
          :height="myHeight"
          :row-key="getRowKeys"
          v-bind="$attrs"
          @selection-change="onSelectChange"
          v-on="$listeners">
        <template #empty>
          <el-button v-if="status==='error'" @click="handleSearchClick">
            加载失败，点击刷新
          </el-button>
          <el-button v-else-if="status==='empty'" @click="handleSearchClick">
            暂无数据，点击刷新
          </el-button>
          <span v-else/>
        </template>
        <el-table-column
            v-if="multiSelection||batchDeleteUrl"
            :reserve-selection="reserveSelection"
            type="selection"
            width="40"
            align="center"/>
        <el-table-column v-if="showRadio" align="center" width="50">
          <template v-slot="scope">
            <el-checkbox
                :value="scope.$index===currentRowIndex"
                @change="onCheckedChange($event,scope.$index)"/>
          </template>
        </el-table-column>
        <slot/>
      </el-table>
      <div style="margin-top: 10px;overflow: hidden">
        <div v-if="$slots.tipBottom" class="tip-bottom">
          <slot name="tipBottom"/>
        </div>
        <el-pagination
            v-if="paginationStatus&&!pageLoading"
            background
            :current-page="currentPage"
            :total="total"
            :page-size="pageSize"
            class="page"
            :page-sizes="[10,15,20,25,30,35,40,50,100,200,500]"
            layout="sizes, total, prev, pager, next, jumper"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"/>
        <el-button v-if="paginationStatus&&pageLoading" class="page" type="primary" :loading="true">加载中</el-button>
      </div>
      <el-button
          v-if="status==='loading'"
          type="warning"
          icon="el-icon-loading"
          class="loading">
        加载中
      </el-button>
    </div>
  </div>
</template>

<script>
  /*查询条件filter必须使用:filter.sync="filter"传递*/
  export default {
    components: {},
    props: {
      module: {
        type: String,
        default: "basic",
      },
      url: {
        type: String,
        required: true,
      },
      totalUrl: {
        type: String,
        required: false,
      },
      batchDeleteUrl: {
        type: String,
        required: false,
      },
      showBatchDeleteBtn: {
        type: Boolean,
        default: true,
      },
      filter: {
        type: Object,
      },
      filterFun: {
        type: Function,
      },
      showExport: {
        type: Boolean,
        default: false,
      },
      showTimeRange: {
        type: Boolean,
        default: false,
      },
      //是否显示清空按钮
      hideClear: {
        type: Boolean,
        default: false,
      },
      hideShowHideBtn: {
        type: Boolean,
        default: false,
      },
      defaultPageSize: {
        type: Number,
        default: 30,
      },
      multiSelection: {
        type: Boolean,
        default: false,
      },
      showRadio: {
        type: Boolean,
        default: false,
      },
      idName: {
        type: String,
        default: "pkId",
      },
      get: {
        type: Boolean,
        default: false,
      },
      paginationStatus: {
        type: Boolean,
        default: true,
      },
      height: {
        type: [String, Number],
        required: false,
      },
      //多选时切换页面记住选项
      reserveSelection: {
        type: Boolean,
        default: false,
      },
      rowLoading: {
        type: Boolean,
        default: false,
      },
      dataFun: {
        type: Function,
      },
      exportUrl: {
        type: String,
        default: null,
      },
      spanMethod: {
        type: Function,
      },
    },
    data() {
      return {
        status: "loading",//loading error empty
        getListType: 1,//1：自动获取，2查询获取，3重置获取
        currentPage: 1,
        total: 0,
        pages: 0,
        tableData: [],
        selection: [],
        //保存一份filter的原始拷贝，用于重置条件
        filterCopy: JSON.stringify(this.filter),
        currentRowIndex: -1,
        myHeight: 0,
        pageSize: this.defaultPageSize,
        parentName: "",
        showAdSearch: true,
        exportLoading: false,
        deleteLoading: false,
        pageLoading: false,
        timeRange: "m6",
      };
    },
    mounted() {
      this.parentName = this.$parent.$options.name;

      //为所有input框添加enter键搜索事件
      let searchBox = document.getElementById("vm-search-" + this._uid);
      this.addSearchListener(searchBox);

      window.addEventListener("resize", this.changeHeight);
      const resizeObserver = new ResizeObserver(() => {
        this.changeHeight();
      });
      resizeObserver.observe(document.getElementById("vm-table-bar"));
      this.$nextTick(() => {
        this.changeHeight();
      });
    },
    beforeDestroy() {
      window.removeEventListener("resize", this.changeHeight);
    },
    methods: {
      //等于-1表示获取当前页
      getList(pageNo) {
        this.status = "loading";
        if (pageNo > 0) {
          this.currentPage = pageNo;
        }
        let filter = this.filter;
        if (this.filterFun) {
          let filterCopy = JSON.parse(JSON.stringify(filter));
          filter = this.filterFun(filterCopy);
        }
        let params = Object.assign({pageSize: this.pageSize, pageNum: this.currentPage, timeRange: this.showTimeRange ? this.timeRange : null}, filter);
        let http = this.get ? this.$http.get(this.module, this.url, params) : this.$http.post(this.module, this.url, params);
        http.then(res => {
          if (this.rowLoading) {
            (res.records || []).forEach((item) => {
              item.loading1 = false;
              item.loading2 = false;
            });
          }
          this.tableData = this.dataFun ? this.dataFun(res) : res.records;
          if (this.totalUrl) {
            this.status = "finish";
            this.getPageTotal(params);
          } else {
            this.total = res.total || 0;
            if (this.total === 0) {
              this.status = "empty";
            } else {
              this.status = "finish";
            }
          }
          this.pages = res.pages;
          this.$emit("on-data", this.tableData);
          this.$nextTick(() => {
            this.changeHeight();
          });
        }).catch(() => {
          this.status = "error";
        });
      },
      getPageTotal(params) {
        this.pageLoading = true;
        let http = this.get ? this.$http.get(this.module, this.totalUrl, params) : this.$http.post(this.module, this.totalUrl, params);
        http.then(res => {
          this.total = res;
          if (this.total === 0) {
            this.status = "empty";
          }
        }).finally(() => {
          this.pageLoading = false;
        });
      },
      handleCurrentChange(pageNo) {
        this.getList(pageNo);
      },
      handleSizeChange(size) {
        this.pageSize = size;
        this.getList(1);
      },
      handleSearchClick() {
        this.getList(1);
        this.$emit("search");
      },
      handleClearClick() {
        this.$emit("update:filter", JSON.parse(this.filterCopy));
        this.$emit("clear");
        this.$nextTick(() => {
          this.getList(1);
        });
      },
      clear() {
        this.tableData = [];
        this.total = 0;
      },
      setCurrentRow(row) {
        this.$refs.elTable.setCurrentRow(row);
      },
      onCheckedChange(val, index) {
        this.currentRowIndex = val ? index : -1;
        this.$emit("radio-change", this.tableData[this.currentRowIndex], val);
      },
      getCurrentRow() {
        return this.tableData[this.currentRowIndex];
      },
      changeHeight() {
        if (!this.$refs.elTable) {
          return;
        }
        if (this._inactive) {
          return;
        }
        if (this.height) {
          this.myHeight = this.height;
        } else {
          let bar = document.getElementById("vm-table-bar");
          if (!bar) {
            return;
          }
          const tableTop = this.$refs.elTable.$el.getBoundingClientRect().top;
          let clientHeight = document.body.clientHeight;
          if (this.parentName === "ElDialog") {
            this.myHeight = clientHeight - tableTop - 150;
          } else if (this.paginationStatus) {
            this.myHeight = clientHeight - tableTop - 62;
          } else {
            this.myHeight = clientHeight - tableTop - 32;
          }
        }
        this.$refs.elTable.doLayout();
      },
      getRowKeys(row) {
        return row.id;
      },
      toggleAdSearch() {
        this.showAdSearch = !this.showAdSearch;
      },
      handleExport() {
        this.$confirm("确定导出吗?", "提示", {type: "warning"}).then(() => {
          this.exportLoading = true;
          let filter = this.filter;
          if (this.filterFun) {
            let filterCopy = JSON.parse(JSON.stringify(filter));
            filter = this.filterFun(filterCopy);
          }
          let params = Object.assign({pageSize: 1000000, pageNum: 1, timeRange: this.showTimeRange ? this.timeRange : null}, filter);
          this.$http.exportExcelByHeader(this.module, this.exportUrl === null ? this.url : this.exportUrl, params, this.exportUrl === null ? this.get ? "get" : "post" : "post")
            .finally(() => {
              this.exportLoading = false;
            });
        });
      },
      onSelectChange(selection) {
        this.selection = selection;
      },
      onBatchDelete() {
        if (!this.batchDeleteUrl) {
          this.$message.error("未配置batchDeleteUrl");
          return;
        }
        if (this.selection && this.selection.length) {
          this.ids = this.selection.map(item => {
            return item[this.idName];
          });
          this.$confirm(`选中${this.ids.length}项，确定删除吗?`, "提示", {type: "warning"}).then(() => {
            this.deleteLoading = true;
            this.$http
              .post(this.module, this.batchDeleteUrl, this.ids)
              .then(() => {
                this.getList(-1);
                this.$message.success("删除成功");
              })
              .finally(() => {
                this.deleteLoading = false;
              });
          });
        } else {
          this.$message.error("请先选择删除项");
        }
      },
      addSearchListener(parent) {
        if (parent) {
          let controls = parent.getElementsByClassName("el-input__inner");
          for (let item of controls) {
            item.onkeydown = event => {
              if (event.key === "Enter") {
                this.getList(1);
              }
            };
          }
        }
      },
    },
  };
</script>

<style lang="scss">
.vm-page-table-v2 {
  position: relative;

  .tools-bar {
    margin-bottom: 6px;
    display: flex;
  }

  .tip {
    font-size: 13px;
    color: red;
    margin-bottom: 6px;

    > * {
      margin-right: 20px;
    }
  }

  .ad-search {
    overflow: auto;
    width: auto;
    border: 1px solid #EBEEF5;
    margin-bottom: 6px;
    background-color: #f4f7fa;
    position: relative;

    .ad-search_content {
      display: inline-block;
      padding: 6px 5px 2px 2px;
    }

    .ad-search-btn {
      position: absolute;
      right: 4px;
      bottom: 4px;
    }
  }

  .page {
    float: right;
  }

  .wrapper {
    position: relative;

    .loading {
      position: absolute;
      margin-left: -50px;
      padding: 6px 10px !important;
      left: 50%;
      top: 25%;
      z-index: 1000;
    }
  }

  .toggle-ad-search {
    background: #409EFF;
    position: absolute;
    padding: 3px 5px;
    cursor: pointer;
    font-size: 12px;
    color: white;
    top: -10px;
    right: -12px;
    border-radius: 1px 2px 1px 1px;
    z-index: 1000;
  }

  .tip-bottom {
    float: left;
    color: red;
    font-size: 13px;
    margin-left: 5px;
    font-weight: 600;
  }

  .ad-search_content {
    .vm-search-com:nth-last-of-type(1)::after {
      content: '　';
      width: 140px;
      height: 28px;
      display: inline-block;
      margin: 2px 0;
    }
  }
}
</style>
